import { apiSlice } from "../../app/api/apiSlice";
import { logOut, setCredentials } from "./authSlice";

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    authenticate: builder.mutation({
      query: (credentials) => ({
        url: "/auth/",
        method: "POST",
        body: { ...credentials },
      }),
      // Store state token in localStorage for recovery after redirect
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          if (data?.state_token) {
            localStorage.setItem("auth_state_token", data.state_token);
          }
        } catch (err) {
          console.error("Authentication setup error:", err);
        }
      },
    }),
    login: builder.mutation({
      query: (credentials) => ({
        url: "/auth/login",
        method: "POST",
        body: { ...credentials },
      }),
    }),
    // authorize: builder.query({
    //   query: (session_token) => ({
    //     url: `/auth/${session_token}/status`,
    //   }),
    // }),
    sendLogout: builder.mutation({
      query: () => ({
        url: "/auth/logout",
        method: "POST",
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          // Clear any state tokens from localStorage
          localStorage.removeItem("auth_state_token");
          dispatch(logOut());
          setTimeout(() => {
            dispatch(apiSlice.util.resetApiState());
          }, 1000);
        } catch (err) {
          console.error("Logout error:", err);
        }
      },
    }),
    refresh: builder.mutation({
      query: () => ({
        url: "/auth/refresh",
        method: "GET",
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          const { accessToken } = data;
          dispatch(setCredentials({ accessToken }));
          // Log successful refresh for debugging
          console.log('Token refresh successful');
        } catch (err) {
          // Enhanced error logging
          console.error("Token refresh error:", err);
          
          // Check if this is a "missing cookie" error
          const isMissingCookie = 
            err?.error?.status === 401 && 
            (err?.error?.data?.message === "Unauthorized" || 
             err?.error?.data?.message?.includes("missing"));
          
          if (isMissingCookie) {
            console.error("Refresh token error: Cookie missing or invalid");
            
            // Clear backup if refresh token is definitely missing
            localStorage.removeItem('session_backup');
            
            // Optional: Could dispatch a special action to show a session expired message
            // dispatch(sessionExpired());
          }
        }
      },
    }),
    sendOtp: builder.mutation({
      query: ({ telephoneNumber, userRole }) => ({
        url: "/auth/send-otp",
        method: "POST",
        body: { phoneNumber: telephoneNumber, roles: userRole },
      }),
    }),
    verifyOtp: builder.mutation({
      query: ({ telephoneNumber, otp, roles }) => ({
        url: "/auth/verify-otp",
        method: "POST",
        body: { phoneNumber: telephoneNumber, otp, roles },
      }),
    }),
    enable2fa: builder.query({
      query: () => ({
        url: "/auth/2FA",
        method: "GET",
      }),
    }),
    verify2fa: builder.mutation({
      query: (body) => ({
        url: "/auth/2FA",
        method: "POST",
        body,
      }),
    }),
    disable2fa: builder.query({
      query: () => ({
        url: "/auth/2FA",
        method: "PUT",
      }),
    }),
  }),
});

export const {
  useAuthenticateMutation,
  useLoginMutation,
  useSendLogoutMutation,
  useRefreshMutation,
  useSendOtpMutation,
  useVerifyOtpMutation,
  useLazyEnable2faQuery,
  useVerify2faMutation,
  useLazyDisable2faQuery,
} = authApiSlice;

